import { DateTime } from 'luxon';

export function formatCurrency(
  value: number | string | undefined | null,
): string {
  if (value === undefined || value === null || value === '') return '-';
  return `$${Number(value).toFixed(2)}`;
}

export function formatDate(value: string | Date | undefined | null): string {
  if (!value) return '-';
  const dateStr = value instanceof Date ? value.toISOString() : value;
  return DateTime.fromISO(dateStr, { zone: 'utc' }).toFormat('MM/dd/yyyy');
}

export function formatRelativeTime(
  value: string | Date | undefined | null,
): string {
  if (!value) return '-';
  const dateStr = value instanceof Date ? value.toISOString() : value;
  return DateTime.fromISO(dateStr).toRelative() || '-';
}

export function formatValue(value: string | number | undefined | null): string {
  if (value === undefined || value === null || value === '') return '-';
  return String(value);
}
